import {useLocalStorage} from "@unibuddy/patron";

export const useAsyncLocalStorage = (key, initialValue) => {
    const [value, setValue] = useLocalStorage(key, initialValue);

    return {value, setValue, loading: false};
};
